import UI from './ui-base';
import noUiSlider from 'nouislider';
import { dataSetToObject } from '../util/dom-util';
import EventHandler from '../_dependencyvendor/event-handler';

// eslint-disable-next-line no-unused-vars
const VERSION = '0.0.1';
const NAME = 'ui.rsliders';

// data-attribute 로 설정 가능한 옵션 들
const dataAttrConfig = {
  blockStep: 0,
};

const defaultConfig = {
  ...dataAttrConfig,
};

class RangeSliderMulti extends UI {
  constructor(element, config = {}) {
    super(element, config);
    this._setupConfog(config);
    this._minStep = -1;
    this._maxStep = -1;
    this._allyStepList = [];
    this._init();
  }

  static get EVENT() {
    return {
      CHANGE: `${NAME}.change`,
    };
  }

  static get NAME() {
    return NAME;
  }

  /**
   * 삭제
   */
  destroy() {
    this._removeVars();
    super.destroy();
  }

  _setupConfog(config) {
    this._config = {
      ...defaultConfig,
      ...config,
      ...dataSetToObject(this._element, dataAttrConfig, 'rsliders'),
    };
  }

  /**
   * 필요에 따라 public으로..
   */
  _init() {
    const a11yStep = this._element.getAttribute('data-rsliders-a11y');
    const allyStepList = a11yStep ? a11yStep.split('|') : null;
    const inputs = this._element.querySelectorAll('input[type="range"]');
    inputs.forEach(el => {
      el.style.display = 'none';
    });

    const stepValue = 100 / (allyStepList.length - 1);
    const range = {};
    for (let i = 0; i < allyStepList.length; i++) {
      if (i === 0) {
        range['min'] = i * stepValue;
      } else if (i === allyStepList.length - 1) {
        range['max'] = i * stepValue;
      } else {
        range[i * stepValue] = i * stepValue;
      }
    }

    noUiSlider.create(this._element, {
      start: [inputs[0].value, inputs[1].value],
      connect: true,
      snap: true,
      range: range,
      margin: stepValue,
    });

    this._element.noUiSlider.on('update', (values, handle, unencoded, tap, positions, noUiSlider) => {
      this._minStep = Math.ceil(Number(values[0]) / stepValue);
      this._maxStep = Math.ceil(Number(values[1]) / stepValue);
      inputs[0].value = Number(values[0]);
      inputs[1].value = Number(values[1]);
      this._updateAria(noUiSlider, allyStepList);
      EventHandler.trigger(this._element, RangeSliderMulti.EVENT.CHANGE, {
        value: [Number(values[0]), Number(values[1])],
      });
    });
  }

  _updateAria(noUiSlider, _allyStepList) {
    if (_allyStepList) {
      const minHandle = noUiSlider.target.querySelector('.noUi-handle-lower');
      const maxHandle = noUiSlider.target.querySelector('.noUi-handle-upper');
      const start = this._minStep;
      const end = this._maxStep;

      const currString = `${_allyStepList[start]}부터 ${_allyStepList[end]}까지`;
      minHandle.setAttribute('aria-valuetext', `범위선택 시작 점, 현재 범위: ${currString}`);
      maxHandle.setAttribute('aria-valuetext', `범위선택 종료 점, 현재 범위: ${currString}`);
    }
  }
}

export default RangeSliderMulti;
